<!-- eslint-disable -->
<template lang="pug">
    .abacus-form__container
        .abacus-form
            .abacus-form__title
                | {{ $i18n.t('trainer.trainer_gameFormSetting_abacusSettings') }}
            form.abacus-form__body(
                action="javascript://"
                @submit="saveGame"
            )
                .abacus-form__field
                    .abacus-form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfSpokes') }}
                    .abacus-form__field-body
                        cs-spin-input(
                            :value="params.numberOfSpokes",
                            :max="13",
                            :min="1",
                            @increase="params.numberOfSpokes++",
                            @decrease="params.numberOfSpokes--",
                            @input="params.numberOfSpokes = $event",
                        )
                .abacus-form__field
                    .abacus-form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_colorOfBones') }}
                    .abacus-form__field-body
                        cs-multiselect(
                            :options="colors"
                            :multiple="false"
                            :close-on-select="true"
                            track-by="text"
                            label="text"
                            :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseColor')"
                            v-model="params.style"
                            v-validate="'required'"
                            date-vv-name="color-selector"
                        )
                .abacus-form__buttons
                    cs-button.abacus-form__button(
                        color="blue"
                        type="submit"
                    )
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_save') }}
</template>

<script>
    /*eslint-disable*/
    import {mapState} from 'vuex'

    export default {
        props: {
            slug: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                params: {
                    numberOfSpokes: 1
                },
                count: '',
                colors: [
                    {
                        text: this.$i18n.t('common.common_gameSetting_colorRed'),
                        backgroundColor: '#ff3d49'
                    },
                    {
                        text: this.$i18n.t('common.common_gameSetting_colorOrange'),
                        backgroundColor: 'rgba(255,109,0,0.8)'
                    },
                    {
                        text: this.$i18n.t('common.common_gameSetting_colorYellow'),
                        backgroundColor: '#ffc61e'
                    },
                    {
                        text: this.$i18n.t('common.common_gameSetting_colorGreen'),
                        backgroundColor: 'rgba(20,141,0,0.87)'
                    },
                    {
                        text: this.$i18n.t('common.common_gameSetting_colorBlue'),
                        backgroundColor: 'rgba(0,0,145,0.85)'
                    },
                ],
            }
        },
        mounted() {
            let paramsArray = this.$store.state.trainer.game;
            if (paramsArray) {
                this.paramsArray = _.cloneDeep(paramsArray);
                this.params = this.paramsArray;
            } else {
                this.params = {
                    numberOfSpokes: 1,
                    style: this.colors[2],
                    slug: this.slug,
                }
            }
            this.paramsArray = this.paramsArray ? this.paramsArray : [];
            this.paramsArray.slug = this.slug;
            this.paramsArray.courseType = 'mental-arithmetic';
        },
        methods: {
            saveGame() {
                this.$validator.validateAll()
                .then(validate => {
                    if (!validate) {
                        this.$toasted.error(this.$i18n.t('errors.fill_form'));
                        return;
                    }
                    this.$store.dispatch('setGame', this.params);
                    this.$store.dispatch('setParamsArray', this.paramsArray);
                    this.$router.push({name: 'tools/abacus'});
                })
            },
            cancel() {
                this.$router.back()
            },
            increase () {
                this.params.numberOfSpokes !== 13 && (this.params.numberOfSpokes += 1);
            },
            decrease () {
                this.params.numberOfSpokes !== 1 && (this.params.numberOfSpokes -= 1);
            },
        },
        computed: {
            ...mapState({
                game: state => state.trainer.game,
            })
        }
    }
</script>

<style lang="scss" scoped>
    .abacus-form__container {
        margin: 0;
        height: 100%;
        background-color: $x-color-white;
        border-radius: $border-radius-40;
        box-sizing: border-box;
        @include media($sm) {
            padding: 30px;
        }
    }

    .abacus-form {
        margin: 0;
        padding: 30px 20px;
        height: 100%;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        flex-direction: column;
        @include media($md) {
            padding: 30px;
        }
    }

    .abacus-form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        margin-bottom: 25px;
    }

    .abacus-form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .abacus-form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 21%;
        }
    }


    .abacus-form__input {
        display: flex;
        align-items: center;
    }

    .abacus-form__input .cs-input {
        margin-bottom: 0;
        &::-webkit-inner-spin-button,
        &::-webkit-outer-spin-button{
            appearance: none;
            margin: 0;
        }
    }

    .input__icon {
        color: $hsl-color-blue-56;
        &:hover {
            color: $hsl-color-blue-48;
        }
    }

    .input__icon--left {
        margin-right: 10px;
    }

    .input__icon--right {
        margin-left: 10px;
    }

    .abacus-form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: .5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }

    .abacus-form__label--image {
        @include media($md) {
            padding-top: 2.5em;
        }
    }

    .abacus-form__divider {
        border: 0;
        background: $hsl-color-gray-74;
        height: 1px;
        width: 100%;
        margin: 30px auto;
    }

    .abacus-form__field-body {
        flex-grow: 5;
    }

    .abacus-form__field-body--bold {
        font-weight: 500;
    }

    .abacus-form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .abacus-form__button {
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }
</style>

